import { render, staticRenderFns } from "./LanguageSelect.vue?vue&type=template&id=3ecdd96f&scoped=true"
import script from "./LanguageSelect.vue?vue&type=script&lang=js"
export * from "./LanguageSelect.vue?vue&type=script&lang=js"
import style0 from "./LanguageSelect.vue?vue&type=style&index=0&id=3ecdd96f&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ecdd96f",
  null
  
)

export default component.exports